module.exports = __webpack_public_path__ + "static/media/joesarkisiangonzosec.89b68a66.png";